export default "__VITE_ASSET__Cl0k7Pso__$_?format=webp__"